import {SessionService} from "./session.service";
import {ChemAPIJs} from "../native/chem.api.js.js";
import {CompanyService} from "../../../business/comp/service/company.service";

export function SessionFactory(session: SessionService, cs: CompanyService, chem: ChemAPIJs) {
  return () => session.initialise(chem, cs);
}
